import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { getStepDetails, getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { environment } from '../../../../../environments/environment';
import { ReferenceLibraryService } from '../../../../services/referenceLibrary.service';
import { GCI140Service } from '../../../../services/gci140.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import moment from 'moment';
import { AppServicesLibraryService } from 'app-services-library';


@Component({
  selector: 'app-generate-forms',
  templateUrl: './generate-forms.component.html',
  styleUrls: ['./generate-forms.component.scss']
})
export class GenerateFormsComponent implements OnInit {
  familyId:any;
  selectedFile:any;
  gcPDFSrc: string;
  i140Src: string;
  g28Src: string;
  i907Src: string;
  gi140lastDocDate: string;
  i907lastDocDate: string;
  g28lastDocDate: string;
  stepDetails: TaskStep;
  disabledControls: boolean;
  subTaskDetails: SubTaskDetails;
  observableSubscription$ = new Subject();
  enotificationAndCCDetails: any;
  
  gi1450lastDocDate: string;
  gi1145lastDocDate: string;
  gi1450Src: string;
  gi1145Src: string;

  generateFormI140:boolean = true;
  uploadedFormI140:boolean = false;
  documentId140;
  isActive140;

  generateFormI907:boolean = true;
  uploadedFormI907:boolean = false;
  documentId907;
  isActive907;

  generateFormG28:boolean = true;
  uploadedFormG28:boolean = false;
  documentIdG28;
  isActiveG28;

  generateFormG1145:boolean = true;
  uploadedFormG1145:boolean = false;
  documentIdG1145;
  isActiveG1145;

  generateFormG1450:boolean = true;
  uploadedFormG1450:boolean = false;
  documentIdG1450;
  isActiveG1450;

  uploadedFileName140;
  uploadedFileName907;
  uploadedFileNameG28; 
  uploadedFileNameG1145; 
  uploadedFileNameG1450; 

  constructor(
    private toastr: ToastrService,
    private store: Store<any>,
    private dynamicDialogConfig: DynamicDialogConfig,
    private pbService: PetitionBuilderService,
    private referenceLibraryService: ReferenceLibraryService,
    private gcI140Service: GCI140Service,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
    this.i140Src = '';
    this.g28Src = '';
    this.i907Src = '';
    this.gcPDFSrc = '';
    this.gi140lastDocDate = "";
    this.i907lastDocDate = "";
    this.g28lastDocDate = "";
    this.gi1450Src = '';
    this.gi1450lastDocDate = "";
    this.gi1145lastDocDate = "";
    this.gi1450Src = "";
    this.gi1145Src = "";
  }

  ngOnInit(): void {
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.subTaskDetails = data;
    });

    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.stepDetails = data;
      this.stepDetails["stepId"] = this.dynamicDialogConfig.data.stepId;
      this.stepDetails["greenCard"] = true;
      this.getGI140FormType();
      this.getGI907FormType();
      this.getG28FormType();
      this.getGformInfo();
      this.toggleControlsStatus();
      this.gcI140Service.getI140Documents(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId, this.dynamicDialogConfig.data.i140CaseId, 'PETFORMDOC').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
        response.data.forEach((element) => {
          if (element.fileCategory && element.fileCategory.code === 'G28') {
            this.g28Src = element['fileLocation'] || '';
            this.g28lastDocDate = element['generatedOn']  ? element['generatedOn'] : '';
            this.generateFormG28 = element.isGenerated;
            this.uploadedFormG28 = element.isUploaded;
            this.documentIdG28    = element.id;
            this.isActiveG28    = element.isActive;
            this.uploadedFileNameG28 = element.uploadedFileName;
          }
          if (element.fileCategory && element.fileCategory.code === 'I907') {
            this.i907Src = element['fileLocation'] || '';
            this.i907lastDocDate = element['generatedOn']  ? element['generatedOn'] : '';
            this.generateFormI907 = element.isGenerated;
            this.uploadedFormI907 = element.isUploaded;
            this.documentId907    = element.id;
            this.isActive907    = element.isActive;
            this.uploadedFileName907 = element.uploadedFileName;
          }
          if (element.fileCategory && element.fileCategory.code === 'I140') {

            this.i140Src = element['fileLocation'] || '';
            this.gi140lastDocDate = element['generatedOn']  ? element['generatedOn'] : '';
            this.generateFormI140 = element.isGenerated;
            this.uploadedFormI140 = element.isUploaded;
            this.documentId140    = element.id;
            this.isActive140    = element.isActive;
            this.uploadedFileName140 = element.uploadedFileName;
          }
          if (element.fileCategory && element.fileCategory.code === 'G1145') {
            this.gi1145Src = element['fileLocation'] || '';
            this.gi1145lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
            this.generateFormG1145 = element.isGenerated;
            this.uploadedFormG1145 = element.isUploaded;
            this.documentIdG1145    = element.id;
            this.isActiveG1145    = element.isActive;
            this.uploadedFileNameG1145 = element.uploadedFileName;
          }
          if (element.fileCategory && element.fileCategory.code === 'G1450') {
            this.gi1450Src = element['fileLocation'] || '';
            this.gi1450lastDocDate = element['generatedOn'] ? element['generatedOn'] : '';
            this.generateFormG1450 = element.isGenerated;
            this.uploadedFormG1450 = element.isUploaded;
            this.documentIdG1450    = element.id;
            this.isActiveG1450    = element.isActive;
            this.uploadedFileNameG1450 = element.uploadedFileName;
          }
        });
      });
    });
  }

  getGI140FormType() {
    this.pbService.getlastPreparedDoc(this.dynamicDialogConfig.data.companyId,
      this.dynamicDialogConfig.data.i140CaseId, 'I140').subscribe(data => {
        if (data) {
          this.i140Src = data['fileLocation'] || '';
          this.gi140lastDocDate = data['generatedOn'] ? data['generatedOn'] : '';
        }
      });
  }

  getGI907FormType() {
    this.pbService.getlastPreparedDocGC(this.dynamicDialogConfig.data.superTaskId,
      this.dynamicDialogConfig.data.i140CaseId, 'I907').subscribe(data => {
        if (data) {
          this.i907Src = data['fileLocation'] || '';
          this.i907lastDocDate = data['generatedOn'] ? data['generatedOn'] : '';
          this.generateFormI907 = data?.isGenerated;
          this.uploadedFormI907 = data?.isUploaded;
          this.documentId907    = data?.id;
          this.isActive907    = data?.isActive;
          this.uploadedFileName907 = data?.uploadedFileName;
        }
      });
  }

  getG28FormType() {
    this.pbService.getlastPreparedDoc(this.dynamicDialogConfig.data.companyId,
      this.dynamicDialogConfig.data.i140CaseId, 'G28').subscribe(data => {
        if (data) {
          this.g28Src = data['fileLocation'] || '';
          this.g28lastDocDate = data['generatedOn'] ? data['generatedOn'] : '';
        }
      });
  }

  getGformInfo() {
    this.pbService.getEnotificationAndCCDetails(
      this.dynamicDialogConfig.data.visatype,
      this.dynamicDialogConfig.data.caseType,
      this.dynamicDialogConfig.data.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          this.enotificationAndCCDetails = response.data;
          console.log("$$$ this.enotificationAndCCDetails", this.enotificationAndCCDetails);
        }
      });
  }


  assignFileSrcAndDate(type, date, src) {
    if (type === 'I140') {
      this.i140Src = src;
      this.gi140lastDocDate = date;
    }
    if (type === 'I907') {
      this.i907Src = src;
      this.i907lastDocDate = date;
    }
    if (type === 'G28') {
      this.g28Src = src;
      this.g28lastDocDate = date;
    }
    if (type === 'G1450') {
      this.gi1450Src = src;
      this.gi1450lastDocDate = date;
    }
    if (type === 'G1145') {
      this.gi1145Src = src;
      this.gi1145lastDocDate = date;
    }
  }

  postGenerateDoc(gcFormtype) {
    const payload = {
      formType: gcFormtype,
    }
    this.pbService.postFormType(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, gcFormtype, payload).subscribe(response => {
      if (response.status === 200 && response.data != null) {
        this.gcPDFSrc = response.data['fileLocation'] || '';
        if (this.gcPDFSrc != '') {
          var _data = response.data;
          let documentId = _data.id;
          let fileName = _data.fileCategory.code;
          let generatedOn = _data.generatedOn;
          let isGenerated = _data.isGenerated;
          let isUploaded = _data.isUploaded;
          let isActive = _data.isActive;
          let getURL  = _data.fileLocation;
          let formType = _data.formName;
          let uploadedFileName = response.data.uploadedFileName;
          this.assignLatestValues({uploadedFileName:uploadedFileName, fileName:fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded:isUploaded, getUrl:getURL, formType:formType, isActive:isActive});
          this.toastr.success(response.message, "Success");// all done
        }
      }
    })
  }

  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  viewGenerateDoc(src) {
    const docPath = src.substring(23);
    window.open(`${environment.docs}${docPath}`, '_blank');
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  getInfoBack(value){
    if(value.key == 'I140'){
      this.generateFormI140 = value.isGenerate;
    }
    else if(value.key == 'I907'){
      this.generateFormI907 = value.isGenerate
    }
    else if(value.key == 'G28'){
      this.generateFormG28 = value.isGenerate;
    }
    else if(value.key == 'G1145'){
      this.generateFormG1145 = value.isGenerate
    }
    else if(value.key == 'G1450'){
      this.generateFormG1450 = value.isGenerate;
    }
   
  }

  getUploadedData(_data:any){
    let files = _data.file[0];
    // if(files.type !== 'application/pdf'){
    //   this.toastr.error("You have selected wrong document", "Please upload PDF file")
    // }
    // else{
      this.selectedFile = files;
      const formData = new FormData();
      formData.append('file', this.selectedFile);

      if(this.familyId == undefined){
        this.familyId = ''
      }
      this.pbService.uploadGreenCardPDF(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, _data.formName, formData)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((response: ImagilityBaseResponse) => {
          if (response.status == 200) {

            this.toastr.success(response.message, "Success");
            var _data = response.data;
            let documentId = response.data.id;
            let fileName = response.data.fileCategory.code;
            let generatedOn = response.data.generatedOn;
            let isGenerated = response.data.isGenerated;
            let isUploaded = response.data.isUploaded;
            let isActive = response.data.isActive;
            let getURL  = response.data.fileLocation;
            let formType = _data.formName;
            let uploadedFileName = response.data.uploadedFileName;
            this.assignLatestValues({uploadedFileName:uploadedFileName, fileName:fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded:isUploaded, getUrl:getURL, formType:formType, isActive:isActive});
          }
        })
    // }

  }

  getDeletedData(_data:any){
    this.pbService.deleteGreenCardPDF(_data.documentId).pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: ImagilityBaseResponse) => {
      this.toastr.success(response.message, "Success");
      var _data = response.data;
      let documentId = response.data.id;
      let fileName = response.data.fileCategory.code;
      let generatedOn = response.data.generatedOn;
      let isGenerated = response.data.isGenerated;
      let isUploaded = response.data.isUploaded;
      let isActive = response.data.isActive;
      let getURL  = response.data.fileLocation;
      let formType = _data.formName;
      let uploadedFileName = response.data.uploadedFileName;
      this.assignLatestValues({uploadedFileName:uploadedFileName, fileName:fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded:isUploaded, getUrl:getURL, formType:formType, isActive:isActive});
    })
  }
    
  assignLatestValues(_data){
   if(_data.fileName == 'I907'){
      this.generateFormI907 = _data.isGenerated;
      this.uploadedFormI907 = _data.isUploaded;
      this.i907lastDocDate  =  _data.generatedOn;
      this.documentId907    = _data.documentID;
      this.i907Src          = _data.getUrl;
      this.isActive907      = _data.isActive;
      this.uploadedFileName907 = _data.uploadedFileName;
    }
    else if(_data.fileName == 'G28'){
      this.generateFormG28 = _data.isGenerated;
      this.uploadedFormG28 = _data.isUploaded;
      this.g28lastDocDate  =  _data.generatedOn;
      this.documentIdG28   = _data.documentID;
      this.g28Src          = _data.getUrl;
      this.isActiveG28      = _data.isActive;
      this.uploadedFileNameG28 = _data.uploadedFileName;
    }
    else if(_data.fileName == 'I140'){
      this.generateFormI140 = _data.isGenerated;
      this.uploadedFormI140 = _data.isUploaded;
      this.gi140lastDocDate =  _data.generatedOn;
      this.documentId140    = _data.documentID;
      this.i140Src          = _data.getUrl;
      this.isActive140      = _data.isActive;
      this.uploadedFileName140 = _data.uploadedFileName;
    }
    else if(_data.fileName == 'G1145'){
      this.generateFormG1145 = _data.isGenerated;
      this.uploadedFormG1145 = _data.isUploaded;
      this.gi1145lastDocDate =  _data.generatedOn;
      this.documentIdG1145    = _data.documentID;
      this.gi1145Src          = _data.getUrl;
      this.isActiveG1145      = _data.isActive;
      this.uploadedFileNameG1145 = _data.uploadedFileName;
    }
    else if(_data.fileName == 'G1450'){
      this.generateFormG1450 = _data.isGenerated;
      this.uploadedFormG1450 = _data.isUploaded;
      this.gi1450lastDocDate =  _data.generatedOn;
      this.documentIdG1450    = _data.documentID;
      this.gi1450Src          = _data.getUrl;
      this.isActiveG1450      = _data.isActive;
      this.uploadedFileNameG1450 = _data.uploadedFileName;
    }
  }

}
